import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { Link as TipTapLink } from '@tiptap/extension-link';
import { mergeAttributes } from '@tiptap/react';
import { elmoSaysThisMightBeADeviationUrl } from '../extension-deviation/helpers';
// From DOMPurify
// https://github.com/cure53/DOMPurify/blob/main/src/regexp.js
const ATTR_WHITESPACE = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g; // eslint-disable-line no-control-regex
const IS_ALLOWED_URI = /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i; // eslint-disable-line no-useless-escape
function isAllowedUri(uri) {
    return !uri || uri.replace(ATTR_WHITESPACE, '').match(IS_ALLOWED_URI);
}
function isInternalLink(url) {
    return /^https:\/\/www\.deviantart\.com/.test(url) || /^#/.test(url) || elmoSaysThisMightBeADeviationUrl(url);
}
export const Link = TipTapLink.extend({
    inclusive: false,
    keepOnSplit: true,
    parseHTML: ()=>[
            {
                tag: 'a[href]:not([href *= "javascript:" i]):not([data-da-type]):not([data-emote])'
            }
        ],
    renderHTML ({ HTMLAttributes }) {
        // prevent XSS attacks
        if (!isAllowedUri(HTMLAttributes.href)) {
            // strip out the href
            return [
                'a',
                mergeAttributes(this.options.HTMLAttributes, _object_spread_props(_object_spread({}, HTMLAttributes), {
                    href: '',
                    rel: 'noopener noreferrer nofollow ugc',
                    target: '_blank'
                })),
                0
            ];
        }
        return [
            'a',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
                rel: 'noopener noreferrer nofollow ugc',
                target: isInternalLink(HTMLAttributes.href) ? '' : '_blank'
            }),
            0
        ];
    }
});

//# sourceMappingURL=link.js.map